// extracted by mini-css-extract-plugin
module.exports = {"container":"container-aVNLD","timelimit":"timelimit-jakl6"};